export * from './lib/bds-customer-smart-components.module';
export * from './lib/components/bds-customer-advanced-select/bds-customer-advanced-select.component';
